import { totalAdminMenu } from './sideBarOption'
import TotalAdminPage from './TotalAdminPage'

export { totalAdminMenu }
export default TotalAdminPage
